

import LessonWrapper from './components/lesson/LessonWrapper.vue';

import LessonIntroduction from './components/lesson/LessonIntroduction.vue';
import LessonGrammar from './components/lesson/LessonGrammar.vue';
import LessonPractice from './components/lesson/LessonPractice.vue';
import LessonReview from './components/lesson/LessonReview.vue';
import LessonListeningPractice from './components/lesson/LessonListeningPractice.vue';
import LessonScript from './components/lesson/LessonScript.vue';
import LessonExam from './components/lesson/LessonExam.vue';
import LessonExplanation from './components/lesson/LessonExplanation.vue';


export default [
  {
    path: '/apps/lesson',
    component: LessonWrapper,
    children: [
      {
        path: ':lesson_id/introduction',
        name: 'lesson.introduction',
        component: LessonIntroduction,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/grammar',
        name: 'lesson.grammar',
        component: LessonGrammar,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/practice',
        name: 'lesson.practice',
        component: LessonPractice,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/review',
        name: 'lesson.review',
        component: LessonReview,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/listening-practice',
        name: 'lesson.listening.practice',
        component: LessonListeningPractice,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/script',
        name: 'lesson.script',
        component: LessonScript,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/exam',
        name: 'lesson.exam',
        component: LessonExam,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/explanation/:step',
        name: 'lesson.explanation',
        component: LessonExplanation,
        meta: {requiresAuth: true},
        props: true
      }
    ]
  }
];